var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 34.4574C57.5504 36.2763 59.1256 37.1857 59.6542 38.3731C60.1153 39.4087 60.1153 40.5913 59.6542 41.6269C59.1256 42.8143 57.5504 43.7237 54.4 45.5426L34.6 56.9741C31.4496 58.793 29.8744 59.7024 28.5819 59.5665C27.4545 59.448 26.4303 58.8567 25.7639 57.9396C25 56.8881 25 55.0693 25 51.4315L25 28.5685C25 24.9307 25 23.1119 25.7639 22.0604C26.4303 21.1433 27.4545 20.552 28.5819 20.4335C29.8745 20.2976 31.4496 21.207 34.6 23.0259L54.4 34.4574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.28deb1b11f29a62a45d4771c057f700f.svg";
export { ForwardRef as ReactComponent };